import { ChevronLeft, ChevronRight } from 'lucide-react'

interface PaginationProps {
  page: number
  pageCount: number
  total: number
  pageSize: number
  onPageChange: (page: number) => void
  onPageSizeChange: (size: number) => void
}

export function Pagination({ page, pageCount, total, pageSize, onPageChange, onPageSizeChange }: PaginationProps) {
  const visible = Array.from({ length: pageCount }, (_, index) => index + 1).filter((value) =>
    value === 1 || value === pageCount || Math.abs(value - page) <= 2,
  )
  return (
    <div className="pagination">
      <span>共 {total.toLocaleString('zh-CN')} 条</span>
      <label>
        <span className="sr-only">每页数量</span>
        <select value={pageSize} onChange={(event) => onPageSizeChange(Number(event.target.value))}>
          {[10, 20, 50].map((size) => <option key={size} value={size}>{size} 条/页</option>)}
        </select>
      </label>
      <div className="page-buttons">
        <button type="button" onClick={() => onPageChange(page - 1)} disabled={page <= 1} aria-label="上一页"><ChevronLeft aria-hidden="true" /></button>
        {visible.map((value, index) => (
          <span key={value} className="page-cluster">
            {index > 0 && value - visible[index - 1] > 1 && <span className="page-ellipsis">…</span>}
            <button type="button" className={value === page ? 'is-current' : ''} onClick={() => onPageChange(value)}>{value}</button>
          </span>
        ))}
        <button type="button" onClick={() => onPageChange(page + 1)} disabled={page >= pageCount} aria-label="下一页"><ChevronRight aria-hidden="true" /></button>
      </div>
    </div>
  )
}
